export const PACKAGE_SLOTS = [
  {
    tier: 'Basic',
    price: '$99',
    isRecommended: false,
    features: [
      { name: 'Listed Until Sold', included: true },
      { name: 'Photos per listing', value: '20 Photos' },
      { name: 'All-inclusive fields for listing', included: true },
      { name: 'Inventory analytics', included: true },
      { name: 'Private message with buyers', included: true },
    ],
  },
  {
    tier: 'Basic+',
    price: '$149',
    isRecommended: true,
    features: [
      { name: 'Photos per listing', value: '30 Photos' },
      {
        name: 'Embed Videos per listing',
        value: '1 Video',
        description: '(Youtube, Vimeo)',
      },
      { name: 'Featured in Search', included: true },
      {
        name: 'Recommend to the top',
        included: true,
        description: '("Similar Vehicles" search)',
      },
      { name: 'All benefits in Basic', included: true },
    ],
  },
  {
    tier: 'Premium',
    price: '$299',
    isRecommended: false,
    features: [
      { name: 'Photos per listing', value: '100 Photos' },
      {
        name: 'Embed Videos per listing',
        value: '3 Videos',
        description: '(Youtube, Vimeo)',
      },
      { name: 'Featured in Homepage', included: true },
      { name: 'Top featured in Search', included: true },
      { name: '"Premium Spotlight" badge', included: true },
      {
        name: 'Featured on Social Media',
        included: true,
        description: '(Instagram & Facebook)',
      },
      {
        name: 'Inclusion to Newsletter',
        included: true,
        description: '(Sent to our active buyers database)',
      },
      {
        name: 'Concierge support',
        included: true,
        description: '(Free optional professional reviews)',
      },
      { name: 'All benefits in Basic+', included: true },
    ],
  },
];
